var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('div',{staticClass:"color-model__picker"},[_c('eye-dropper',{ref:"dropper",on:{"change":_vm.onDropperChange,"mount":_vm.onDropperMount}}),_vm._v(" "),_c('color-picker',{attrs:{"preset-colors":_vm.recentColors},on:{"input":_vm.onInput},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }